import { decimal } from '@vuelidate/validators';

export default {
    decimal
};